var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 pt-3"},[_c('button',{staticClass:"menuSectionBtn",on:{"click":function($event){return _vm.scrollToSection(_vm.section.sectionFrontId)}}},[_vm._v(_vm._s(_vm.section.section))])])}
var staticRenderFns = []

export { render, staticRenderFns }